import { Switch, Route, Redirect } from 'react-router-dom';
import React from 'react';
import loadRoute from 'launch/components/loadRoute';

const BookCoverDesign = ({ match, location }) => (
    <Switch>
        <Route
            path={`${match.url}/book-type`}
            component={loadRoute(done => require(['launch/components/BriefBookType'], done))}
        />
        <Route
            path={`${match.url}/designs`}
            component={loadRoute(done => require(['launch/components/BriefStyleSelector'], done), {
                withStyleAssessment: false,
            })}
        />
        <Route
            path={`${match.url}/colors`}
            component={loadRoute(done => require(['launch/components/BriefStyleColors'], done))}
        />
        <Redirect from="*" to={{ ...location, pathname: `${match.url}/book-type` }} />
    </Switch>
);

export default BookCoverDesign;
